import { BrowserRouter, Routes, Route, Navigate} from "react-router-dom"
import  Epedidos from '../pages/Epedidos/Epedidos'
import  Login from '../pages/Login/Login'
import ChangePassword from '../pages/Login/ChangePassword'
import  Error from "../pages/Error/Error";
// import WebhookTest from '../pages/WebhookTest/WebhookTest';
import { useAuth } from "../context/AuthContext";
  
const PrivateRoute = () => {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? <Epedidos /> : <Navigate to="/" />;
};

const PrivateRouteEpedidos = () => {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? <Navigate to="epedidos" replace /> : <Login />;
};

/*
const PrivateRouteWebhookTest = () => {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? <WebhookTest /> : <Navigate to="/" />;
};
*/

const PrivateRouteErro = () => {
  const { isAuthenticated } = useAuth();
  return !isAuthenticated ? <Login/> : <Error />;
};

export default function RouterPage() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<PrivateRouteEpedidos />} />
        <Route path="/epedidos" element={<PrivateRoute />} />
        <Route path="/change-password" element={<ChangePassword />} />
        {/* <Route path="/webhook-test" element={<PrivateRouteWebhookTest />} /> */}
        <Route path="*" element={<PrivateRouteErro />} />
      </Routes>
    </BrowserRouter>
  );
};